import { FC } from 'react';
import { useTranslation } from "react-i18next";

import classes from "./styles.module.css";
import Title from "../title/Title";
import Products from "./productsSlider/ProductsSlider";
import { ProductItemType } from 'src/types/products/ProductItem';


interface NewsetProp {
    data: ProductItemType[]
}

const Newset: FC<NewsetProp> = ({ data }) => {
    const { t } = useTranslation(['home']);


    return (
        <section className={classes.newset}>
            <div className="container">
                <div className={classes.sectionShell}>
                    <Title title={t("newset.title")} />
                    <Products data={data} productVariant="home" cardClassName="p-1 py-2" />
                </div>
            </div>
        </section>
    )
}

export default Newset;
